import cx from "clsx";
import CircularProgress$Indeterminate from "kreate-common/modules/kreate-ui/components/CircularProgress/components/CircularProgress$Indeterminate";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import { httpGet$GetUserList } from "kreate-server/commands/GetUserList/fetcher";
import { GetUserList$Params } from "kreate-server/commands/GetUserList/typing";
import React from "react";
import useSWR from "swr";

import ArtistCard from "../../../PageHome/containers/SectionNewArtists/containers/ArtistCard";

import styles from "./index.module.scss";

import { useIsGonnaVisible } from "@/modules/common-hooks/useIsGonnaVisible";
import ErrorViewer from "@/modules/kreate-components/components/ErrorViewer";

type LoadEvent = {
  maybeHasMore: boolean;
  totalNumResults: number | null | undefined;
};

type Props = {
  className?: string;
  style?: React.CSSProperties;
  params: GetUserList$Params;
  onLoad?: (event: LoadEvent) => void;
};

export default function LazyUserList({
  className,
  style,
  params,
  onLoad,
}: Props) {
  const [containerRef, setContainerRef] = React.useState<HTMLDivElement | null>(
    null
  );

  const [enabled, setEnabled] = React.useState(false);

  const isGonnaVisible = useIsGonnaVisible({
    element: containerRef,
    rootMargin: "20%",
    disabled: enabled,
  });

  const newEnabled = enabled || isGonnaVisible;
  React.useEffect(() => {
    setEnabled(newEnabled);
  }, [newEnabled]);

  const { data: usersData, error: usersError } = useSWR(
    enabled ? ["13bb8992-83d0-4c7a-928e-17c25b3ef79b", params] : null,
    async () => await httpGet$GetUserList("/api/v1/all-users", params)
  );

  const usersLength = usersData?.users.length;
  React.useEffect(() => {
    if (usersLength == null) return;
    onLoad?.({
      maybeHasMore: usersLength === params.limit,
      totalNumResults: usersData?.count,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usersLength, params.limit]);

  return (
    <div
      ref={setContainerRef}
      className={cx(styles.container, className)}
      style={style}
    >
      {usersError ? (
        <ErrorViewer className={className} style={style} error={usersError} />
      ) : !usersData ? (
        <Flex.Row
          className={styles.loading}
          alignItems="center"
          justifyContent="center"
          gap="16px"
        >
          <CircularProgress$Indeterminate size="24px" />
          <span>{"Loading..."}</span>
        </Flex.Row>
      ) : (
        usersData.users.map((user) => (
          <ArtistCard
            key={user.userId}
            className={styles.artistCard}
            artist={user}
            enableActions
            openInNewTab={true}
          />
        ))
      )}
    </div>
  );
}
